module.exports = __webpack_public_path__ + "img/213.c13f3f37.png";